import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { consentStatus, setConsent } from '../lib/analytics';

/** Banner de consentimento (LGPD) — só no site público; gateia GA4 + Clarity. */
export function ConsentBanner() {
  const { t } = useTranslation();
  const [show, setShow] = useState(consentStatus() === null);
  if (!show) return null;
  return (
    <div className="consent" role="dialog" aria-label={t('consent.text')}>
      <span className="consent__text">
        {t('consent.text')} <Link to="/privacidade">{t('legal.privacy')}</Link>
      </span>
      <div className="consent__btns">
        <button type="button" className="btn btn--ghost btn--sm" onClick={() => { setConsent(false); setShow(false); }}>{t('consent.decline')}</button>
        <button type="button" className="btn btn--primary btn--sm" onClick={() => { setConsent(true); setShow(false); }}>{t('consent.accept')}</button>
      </div>
    </div>
  );
}
